import { render, staticRenderFns } from "./birthdays.vue?vue&type=template&id=6b6a27c1"
import script from "./birthdays.vue?vue&type=script&lang=js"
export * from "./birthdays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports